import React from 'react';
import { SuperadminUser } from './superadminUser';
import { CreatableUser } from './creatableUser';
import { useCurrentUserRole } from 'store/user';

export const CurrentUser = (): React.ReactElement => {
  const userRole = useCurrentUserRole();
  const isSuperAdmin = userRole === 'superadmin';

  if (isSuperAdmin) {
    return <SuperadminUser />;
  }

  return <CreatableUser />;
};
